import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import store from "./redux";
import { Provider } from "react-redux";
import App from "./App";
import { I18nProvider } from "./i18n";
import "./custom-antd.css";
import "./index.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    const msg = error ? (error.message || error.toString()) : '';
    if (msg.indexOf('ResizeObserver') > -1) {
      return { hasError: false, error: null, errorInfo: null };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const msg = error ? (error.message || error.toString()) : '';
    if (msg.indexOf('ResizeObserver') > -1) {
      return;
    }
    if (error?.name === 'ChunkLoadError' || /loading.*chunk.*failed/i.test(msg) || /ChunkLoadError/i.test(msg)) {
      const now = Date.now();
      const lastReload = parseInt(sessionStorage.getItem('last_chunk_reload') || '0', 10);
      if (now - lastReload > 10000) {
        sessionStorage.setItem('last_chunk_reload', String(now));
        window.location.reload();
        return;
      }
    }
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, fontFamily: 'monospace', backgroundColor: '#fff', minHeight: '100vh', color: '#333' }}>
          <h2 style={{ color: '#e53935' }}>⚠️ Ошибка рендеринга React:</h2>
          <pre style={{ backgroundColor: '#fbe9e7', color: '#c62828', padding: 20, borderRadius: 8, overflowX: 'auto', fontSize: '14px' }}>
            {this.state.error && (this.state.error.stack || this.state.error.toString())}
          </pre>
          <details style={{ marginTop: 20, whiteSpace: 'pre-wrap' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Стек компонентов:</summary>
            <pre style={{ backgroundColor: '#eceff1', padding: 15, borderRadius: 8, fontSize: '12px', marginTop: 10 }}>
              {this.state.errorInfo?.componentStack}
            </pre>
          </details>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 20,
              padding: '10px 20px',
              backgroundColor: '#1890ff',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Перезагрузить страницу
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <I18nProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nProvider>
    </Provider>
  </ErrorBoundary>,
  document.getElementById("root")
);


